var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-multi-comp: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { FormattedMessage } from 'react-intl';
import { TSS_BLACK, TSS_DARK_BLUE, createChainableTypeChecker } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';

import { Dropdown, dropdownValueProps } from './Dropdown';
import ToolTip from './Tooltip';
import SearchInput from './SearchInput';
import DatePickerInput from './DatePickerInput';
import { IconButton } from './buttons';
import { IMG_ICON_LOOKING_GLASS, IMG_ICON_CROSS_SMALL } from '../img';

var styles = void 0;

export var datePropType = createChainableTypeChecker(function (props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];
    if (value !== Date) {
      return new Error(propName + ' in ' + (componentName || 'ANNONYMOUS') + ' is not a Date');
    }
  }

  return null;
});

export var dateRangePropType = createChainableTypeChecker(function (props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];
    if (value !== 'DateRange') {
      return new Error(propName + ' in ' + (componentName || 'ANNONYMOUS') + ' is not a Date');
    }
  }
  return null;
});

var filterSettingPropTypeObj = {
  staticLabel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  sorter: PropTypes.func,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  values: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType(dropdownValueProps).isRequired
  })), datePropType, dateRangePropType]).isRequired
};

export var filterSettingPropType = PropTypes.shape(filterSettingPropTypeObj);

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Filter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filter.__proto__ || Object.getPrototypeOf(Filter)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
      return _this.props.onChange(_this.props.id, value);
    }, _this.handleDateChange = function (value) {
      return _this.props.onChange(_this.props.id, value.unix() * 1000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var children = null;
      if (this.props.values === Date) {
        children = React.createElement(DatePickerInput, {
          isStatic: true,
          max: this.props.id === 'fromDate' ? this.props.maxDate : null,
          min: this.props.id === 'toDate' ? this.props.minDate : null,
          placeholder: this.props.staticLabel,
          onChange: this.handleDateChange
        });
      } else if (this.props.values === 'DateRange') {
        children = React.createElement(DatePickerInput, {
          isStatic: true,
          max: this.props.maxDate,
          min: this.props.minDate,
          placeholder: this.props.staticLabel,
          onChange: this.handleDateChange
        });
      } else {
        children = React.createElement(Dropdown, Object.assign({}, this.props, {
          items: this.props.values,
          sorter: this.props.sorter,
          disabled: this.props.disabled,
          isStatic: true,
          staticLabel: this.props.staticLabel,
          style: styles.dropdownStyle,
          listStyle: styles.dropdownListStyle,
          onChange: this.handleChange
        }));
      }
      return React.createElement(
        'div',
        { className: css(styles.filterContainer) },
        children,
        this.props.disabled && this.props.disabledReason ? React.createElement(
          ToolTip,
          null,
          this.props.disabledReason
        ) : null
      );
    }
  }]);

  return Filter;
}(Component);

Filter.propTypes = Object.assign({}, filterSettingPropTypeObj, {
  onChange: PropTypes.func.isRequired
});


export var FilterControls = function (_Component2) {
  _inherits(FilterControls, _Component2);

  function FilterControls(props) {
    _classCallCheck(this, FilterControls);

    var _this2 = _possibleConstructorReturn(this, (FilterControls.__proto__ || Object.getPrototypeOf(FilterControls)).call(this, props));

    _this2.setSearchRef = function (ref) {
      _this2.searchRef = ref;
    };

    _this2.handleSearchOpen = function () {
      if (!_this2.state.searchOpen) {
        _this2.setState({ searchOpen: true }, function () {
          return setTimeout(function () {
            return _this2.searchRef.focus();
          }, 0);
        });
      }
    };

    _this2.handleFilterChange = function (id, value) {
      return _this2.props.onFilterChange && _this2.props.onFilterChange(id, value);
    };

    _this2.handleSearchChange = function (value) {
      return _this2.props.onSearchChange && _this2.props.onSearchChange(value);
    };

    _this2.handleSearchClear = function () {
      return _this2.props.onSearchClear && _this2.props.onSearchClear();
    };

    _this2.handleFilterClear = function () {
      if (_this2.props.onSearchChange) {
        _this2.props.onSearchChange('');
      }
      if (_this2.props.searchQuery === '') {
        _this2.setState({ searchOpen: false });
      } else {
        _this2.handleSearchClear();
        _this2.searchRef.focus();
      }
    };

    _this2.state = {
      searchOpen: props.searchQuery && props.searchQuery.length
    };
    return _this2;
  }

  _createClass(FilterControls, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var search = null;
      if (this.props.onSearchChange) {
        search = React.createElement(
          'div',
          { className: css(styles.searchContainer) },
          React.createElement(
            'div',
            {
              className: css(styles.searchContainerInner, !this.state.searchOpen && styles.searchContainerInnerMinimized),
              role: 'button',
              tabIndex: 0,
              onClick: this.handleSearchOpen
            },
            this.state.searchOpen ? React.createElement(SearchInput, {
              value: this.props.searchQuery,
              inputRef: this.setSearchRef,
              onChange: this.handleSearchChange,
              onClear: this.handleFilterClear
            }) : React.createElement(
              'div',
              { className: css(styles.searchPlaceholder) },
              React.createElement(Icon, { src: IMG_ICON_LOOKING_GLASS, stroke: TSS_BLACK(), className: css(styles.searchIcon) }),
              React.createElement(FormattedMessage, { id: 'label.search' })
            )
          )
        );
      }
      return React.createElement(
        'div',
        { className: css(styles.container) },
        React.createElement(
          'div',
          { className: css(styles.filterListContainer) },
          this.props.filters.map(function (_ref2) {
            var staticLabel = _ref2.staticLabel,
                id = _ref2.id,
                sorter = _ref2.sorter,
                values = _ref2.values,
                min = _ref2.min,
                max = _ref2.max,
                props = _objectWithoutProperties(_ref2, ['staticLabel', 'id', 'sorter', 'values', 'min', 'max']);

            return React.createElement(Filter, Object.assign({}, props, {
              maxDate: max || _this3.props.maxDate,
              minDate: min || _this3.props.minDate,
              staticLabel: staticLabel,
              sorter: sorter,
              values: values,
              id: id,
              key: id,
              onChange: _this3.handleFilterChange
            }));
          })
        ),
        search
      );
    }
  }]);

  return FilterControls;
}(Component);

FilterControls.propTypes = {
  filters: PropTypes.arrayOf(filterSettingPropType),
  minDate: PropTypes.number,
  maxDate: PropTypes.number,
  searchQuery: PropTypes.string,
  onFilterChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onSearchClear: PropTypes.func
};
FilterControls.defaultProps = {
  filters: [],
  searchQuery: '',
  onFilterChange: null,
  onSearchChange: null,
  onSearchClear: null,
  minDate: null,
  maxDate: null
};
var filterValueObj = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType(dropdownValueProps).isRequired,
  displayValue: PropTypes.string
};

export var filterValuePropType = PropTypes.shape(filterValueObj);

var FilterValue = function (_Component3) {
  _inherits(FilterValue, _Component3);

  function FilterValue() {
    var _ref3;

    var _temp2, _this4, _ret2;

    _classCallCheck(this, FilterValue);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref3 = FilterValue.__proto__ || Object.getPrototypeOf(FilterValue)).call.apply(_ref3, [this].concat(args))), _this4), _this4.handleCloseClick = function () {
      return _this4.props.onCloseClick(_this4.props.id, _this4.props.value);
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  _createClass(FilterValue, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: css(styles.filterValueBox) },
        React.createElement(
          'span',
          { className: css(styles.filterValueLabel) },
          this.props.label,
          ':'
        ),
        React.createElement(
          'span',
          { className: css(styles.filterValueValue) },
          typeof this.props.displayValue !== 'undefined' ? this.props.displayValue : this.props.value
        ),
        React.createElement(
          IconButton,
          { onClick: this.handleCloseClick },
          React.createElement(Icon, { src: IMG_ICON_CROSS_SMALL, stroke: TSS_DARK_BLUE(0.25) })
        )
      );
    }
  }]);

  return FilterValue;
}(Component);

FilterValue.propTypes = Object.assign({}, filterValueObj, {
  onCloseClick: PropTypes.func.isRequired
});


export var FilterSummary = function FilterSummary(_ref4) {
  var filterValues = _ref4.filterValues,
      onCloseClick = _ref4.onCloseClick,
      onClearAllClick = _ref4.onClearAllClick;
  return React.createElement(
    'div',
    { className: css(styles.filterSummaryContainer) },
    React.createElement(
      'div',
      { className: css(styles.filterSummaryLabel) },
      React.createElement(FormattedMessage, { id: 'label.filters' }),
      ':'
    ),
    React.createElement(
      'div',
      { className: css(styles.filterValuesList) },
      filterValues.map(function (_ref5) {
        var id = _ref5.id,
            label = _ref5.label,
            value = _ref5.value,
            displayValue = _ref5.displayValue;
        return React.createElement(FilterValue, {
          key: id + '-' + label + '-' + value,
          id: id,
          label: label,
          displayValue: displayValue,
          value: value,
          onCloseClick: onCloseClick
        });
      })
    ),
    React.createElement(
      'button',
      { className: css(styles.clearAllButton), onClick: onClearAllClick },
      React.createElement(FormattedMessage, { id: 'label.clear.all' })
    )
  );
};

FilterSummary.propTypes = {
  filterValues: PropTypes.arrayOf(filterValuePropType).isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onClearAllClick: PropTypes.func.isRequired
};

styles = StyleSheet.create({
  container: {
    maxHeight: '33px',
    display: 'flex'
  },

  filterListContainer: {
    display: 'flex',
    alignItems: 'center'
  },

  dropdownStyle: {
    minWidth: 'auto',
    height: 'auto'
  },

  dropdownListStyle: {
    minWidth: '15rem',
    left: 'auto',
    right: 0
  },

  searchContainer: {
    borderLeft: '1px solid ' + TSS_DARK_BLUE(0.2),
    padding: '0 0 0 0.8rem',
    margin: '0 0 0 1.6rem'
  },

  searchContainerInner: {
    display: 'flex',
    alignItems: 'center',
    outline: 0,
    cursor: 'pointer',
    padding: '0 1.6rem'
  },

  searchContainerInnerMinimized: {
    padding: '0.8rem 1.6rem',
    ':hover': {
      backgroundColor: TSS_DARK_BLUE(0.1)
    }
  },

  searchPlaceholder: {
    color: TSS_BLACK(),
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem'
  },

  searchIcon: {
    margin: '0 1rem 0 0'
  },

  filterSummaryContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },

  filterSummaryLabel: {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    color: TSS_BLACK(0.5),
    margin: '0 1.6rem 0 0',
    position: 'relative',
    top: '1.4rem'
  },

  filterValuesList: {
    display: 'flex',
    flexWrap: 'wrap'
  },

  filterValueBox: {
    border: '1px solid ' + TSS_DARK_BLUE(0.25),
    borderRadius: 4,
    padding: '0.8rem',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    margin: '0.4rem',
    fontSize: '1.4rem'
  },

  filterValueLabel: {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    color: TSS_BLACK(0.5)
  },

  filterValueValue: {
    margin: '0 0.6rem',
    position: 'relative',
    top: -1
  },

  clearAllButton: {
    outline: 0,
    border: 0,
    backgroundColor: 'transparent',
    margin: '0 1.6rem',
    padding: '0.8rem',
    color: TSS_DARK_BLUE(),
    fontWeight: 600,
    fontSize: '1.4rem',
    position: 'relative',
    top: '0.6rem',
    cursor: 'pointer'
  }
});